module.exports = __webpack_public_path__ + "static/img/img2-5.f049559.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/126/img2-5.jpg
// module id = i/hX
// module chunks = 0